import {
  CenterExceptionalExpense,
  UpdateCenterExceptionalExpenseInput
} from '../../../lib/types/models/center/center-exceptional-expenses'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export function updateCenterExceptionalExpenses(
  id: number,
  data: UpdateCenterExceptionalExpenseInput[]
) {
  return restApiClient
    .url(constructApiUrl(API.centers.updateCenterExceptionalExpenses.url, { id }))
    .patch<CenterExceptionalExpense[], UpdateCenterExceptionalExpenseInput[]>(data)
}
